import { createStore, createEffect, createEvent, combine, sample } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtilsV2 } from '@shared/utils';
import { DashboardApi, RequestStrategyEnum, type WithSignal, type Notification, type UpdateNotificationRequest } from '@shared/api';

const getNotificationsEffect = createEffect(({ signal }: WithSignal = {}) => DashboardApi.getNotifications(signal));
const updateNotificationsEffect = createEffect((request: UpdateNotificationRequest) => DashboardApi.updateNotifications(request));
const deleteNotificationsEffect = createEffect((request: UpdateNotificationRequest) => DashboardApi.deleteNotification(request));
const clearEvent = createEvent();

const $dataStore = createStore<Notification[]>([])
  .on(getNotificationsEffect.done, (_, data) => data.result.data ?? [])
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getNotificationsEffect.pending, (_, data) => data)
  .on(getNotificationsEffect.fail, () => false)
  .on(getNotificationsEffect.done, () => false)
  .on(deleteNotificationsEffect.pending, (_, data) => data)
  .on(deleteNotificationsEffect.fail, () => false)
  .on(deleteNotificationsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getNotificationsEffect, () => null)
  // .on(getNotificationsEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getNotificationsEffect.fail, () => 'Something went wrong while fetching Notifications. Please try again.')
  .on(getNotificationsEffect.done, () => null)
  .reset(clearEvent);
const $actionsErrorStore = createStore<string | null>(null)
  .on(updateNotificationsEffect, () => null)
  // .on(updateNotificationsEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(updateNotificationsEffect.fail, () => 'Something went wrong while updating Notification. Please try again.')
  .on(updateNotificationsEffect.done, () => null)
  .on(deleteNotificationsEffect, () => null)
  // .on(deleteNotificationsEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(deleteNotificationsEffect.fail, () => 'Something went wrong while deleting Notification. Please try again.')
  .on(deleteNotificationsEffect.done, () => null)
  .reset(clearEvent);
$actionsErrorStore.watch((error) => $notificationStore.events.setError(error));

sample({ source: deleteNotificationsEffect.doneData, filter: (data) => data.data != null, target: clearEvent });
updateNotificationsEffect.done.watch(() => getNotificationsEffect());

export const $dashboardNotificationStore = {
  events: {
    getAll: ApiUtilsV2.wrapperApi(getNotificationsEffect, RequestStrategyEnum.Debounce).trigger,
    markAllAsRead: updateNotificationsEffect,
    delete: deleteNotificationsEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
